// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"218":"673892a9","263":"82d4190b","304":"94ac82ae","336":"6ed71026","481":"6d3ccad0","582":"9b35d01d","787":"61e73342","790":"d54999cf","828":"f5e97d52"}[chunkId] + ".chunk.js";
};